import {useGetCurrentUserQuery} from '../redux/services/userApi';

const useUser = () => {
  const userQuery = useGetCurrentUserQuery();
  if (userQuery.error && userQuery.error) return undefined;
  const user = userQuery?.data?.data?.[0] || null;
  return user;
};

export default useUser;
